<div class="score-card">
  <mat-card appearance="outlined">
    <ng-container *ngIf="snapshotSummary | async as summary; else loading">
      <ng-container [ngSwitch]="summary?.result">
        <ng-container *ngSwitchCase="'valid'">
          <div class="scorecard-header-container">
            <div class="header-content-container">
              <snap-overall-score [overallScore]="summary?.score"></snap-overall-score>

              <div class="header-details">
                <span class="business-name">{{ summary?.companyName }}</span>
                <span class="business-address">{{ address | async }}</span>
              </div>
            </div>
          </div>

          <ng-container *ngIf="isLessThan24HoursOld | async">
            <div class="snapshot-status-container">
              <glxy-alert type="tip" [size]="'small'">
                <span [innerHTML]="'SNAPSHOT_STATUS.NOT_READY' | translate"></span>
              </glxy-alert>
            </div>
          </ng-container>

          <ng-container *ngFor="let section of summary?.sections">
            <snap-section-grade [section]="section" [showGrade]="!!summary?.score"></snap-section-grade>
          </ng-container>
          <snap-action-refresh
            [snapshotName]="snapshotName"
            [created]="summary?.created"
            [expired]="summary?.expired"
            [trackingProperties]="trackingProperties | async"
            (refreshSnapshotClicked)="onRefreshSnapshotClicked()"
          ></snap-action-refresh>
          <ng-container *ngIf="snapshotUrl | async as snapshotURL">
            <snap-actions
              [trackingProperties]="trackingProperties | async"
              [snapshotURL]="snapshotURL"
              [enableURLCopy]="enableURLCopy"
              [showEditButton]="showEditButton"
              (viewSnapshotClicked)="onViewSnapshotClicked(snapshotURL)"
              (editSnapshotClicked)="onEditSnapshotClicked()"
            ></snap-actions>
          </ng-container>
        </ng-container>

        <ng-container *ngSwitchCase="'not-ready'">
          <snap-not-ready [snapshotName]="snapshotName"></snap-not-ready>
        </ng-container>

        <ng-container *ngSwitchDefault>
          <snap-not-supported [snapshotName]="snapshotName"></snap-not-supported>
          <snap-action-refresh
            [snapshotName]="snapshotName"
            [trackingProperties]="trackingProperties | async"
            (refreshSnapshotClicked)="onRefreshSnapshotClicked()"
          ></snap-action-refresh>
          <ng-container *ngIf="snapshotUrl | async as snapshotURL">
            <snap-actions
              [snapshotURL]="snapshotURL"
              [trackingProperties]="trackingProperties | async"
              [enableURLCopy]="enableURLCopy"
              (viewSnapshotClicked)="onViewSnapshotClicked(snapshotURL)"
            ></snap-actions>
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>
  </mat-card>
</div>

<ng-template #loading>
  <mat-spinner [diameter]="30" class="loading"></mat-spinner>
</ng-template>
